import { take } from 'rxjs/operators';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AcompanhamentoCorrecoesErrosCteComponent } from '../acompanhamento-correcoes-erros-cte.component';
import { ConsultaCorrecoesErrosCteModelResponse } from '../acompanhamento-correcoes-erros-cte.model';
import { ModalDetalhesComponent } from '../modal-detalhes/modal-detalhes.component';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-acompanhamento-correcoes-erros-cte-grid-pesquisa',
  templateUrl: './acompanhamento-correcoes-erros-cte-grid-pesquisa.html',
  styleUrls: ['./acompanhamento-correcoes-erros-cte-grid-pesquisa.scss']
})
export class AcompanhamentoCorrecoesErrosCteGridPesquisaComponent implements OnInit {
  public grid: MatTableDataSource<ConsultaCorrecoesErrosCteModelResponse> = new MatTableDataSource<ConsultaCorrecoesErrosCteModelResponse>();

  @Input() parent: AcompanhamentoCorrecoesErrosCteComponent;
  @Input() gridData;

  ngOnChanges(changes: SimpleChanges) {
    this.grid.data = changes['gridData'].currentValue;
  }

  get exibirGrid() { return this.parent.exibirGrid; }
  set exibirGrid(value) { this.parent.exibirGrid = value; }

  get isLoading() { return this.parent.isLoading; }
  set isLoading(value) { this.parent.isLoading = value; }

  get isLoadingDownload() { return this.parent.isLoadingDownload; }
  set isLoadingDownload(value) { this.parent.isLoadingDownload = value; }

  get paging() { return this.parent.paging; }
  set paging(value) { this.parent.paging = value; }

  public displayedColumns: string[] = [
    "action",
    "usuario",
    "clienteNome",
    "lote",
    "qtdCte",
    "qtdeNrt",
    "qtdNF",
    "totalFrete",
    "dataInclusao",
    "acoes",
    "status",
    "concluido"
  ];

  constructor(
    public dialog: MatDialog,
    private router: Router,
    public snackBar: MatSnackBar
  ) {
    this.grid.data = this.gridData;
  }

  ngOnInit() {}

  //ALTERAR DE ACORDO COM A RESPOSTA DA API
  getClass(status: string) {
    if(status === '100% Autorizados') return 'green';
    if(status === 'Aguardando Processamento') return 'yellow';
    if(status !== '100% Autorizados' && 'Aguardando Processamento') return 'red';
    return '';
  }

  detalhesLote(grid) {
    if(grid.identificador){

      const url = `#/gestao/cte/lotes-processamento/${grid.identificador}`
      this.router.navigate([]).then(() =>  window.open(url, '_blank') );

      // this.router.navigate(['/documentos-fiscais/gestao-de-cte/lote', grid.identificador]);
    }else{
      this.openSnackBar(
        `Não foi encontrado um identificador válido para prosseguir com detalhes.`,
        "OK",
        5000,
        "danger-snackbar"
      );
    }
  }

  limparPesquisa() {
    this.grid.data = null;
    this.exibirGrid = false;
    this.isLoading = false;
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
